import axios from 'src/api/Api';
import { put } from 'redux-saga/effects';
import {
    GET_DISTRICT_PHYSICIAN_SUCCESS,
    GET_DISTRICT_PHYSICIAN_FAILURE,
} from '../actions';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getDistrictViewPhysician(action) {
    const isOrderListingPage = action.payload;
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/aardt/districts?isOrderListingPage=${encodeURIComponent(isOrderListingPage)}`;

    try {
        const result = yield axios.get(url).then((response) => response.data);

        if (result.districts?.length > 0) {
            const districtLists = result.districts.map((district) => {
                return {
                    ...district,
                    id: district.districtCode,
                    name: district.districtName,
                };
            });

            result.districts = [...districtLists];
        }

        yield put({ type: GET_DISTRICT_PHYSICIAN_SUCCESS, data: result });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_DISTRICT_PHYSICIAN_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
